import { ZipHelper } from '../serializer';

export const sourceToZip = async (inputFiles: File[]): Promise<Blob> => {
  const zip = new ZipHelper();
  inputFiles.forEach((file) => {
    zip.addBlob(file, 'src', file.name);
  });
  return zip.serialize();
};
